// export const domain = "http://localhost:4000";
export const domain = "https://onlinecourses-api-production-e5b5.up.railway.app";